/**
 * Copyright (c) 2022-2026 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

export const ColorThemeCategory = {
    Atom: 'Atom Property',
    Chain: 'Chain Property',
    Residue: 'Residue Property',
    Symmetry: 'Symmetry',
    Validation: 'Validation',
    Particle: 'Particle',
    Misc: 'Miscellaneous',
};